module.exports = "./img/3f2165ffb70cd7669f38fcf7e9d28319.jpg";